import { z } from 'zod';
export const financeReportingProjectFinancialsCapability = 'finance.reporting-project-financials.v1';
export const financeReportingProjectFinancialsSlot = 'reporting.finance-project-financials';
export const financeReportingProjectFinancialsProviderId = 'finance.server.reporting-project-financials';
const centsSchema = z.number().int().nonnegative().max(Number.MAX_SAFE_INTEGER);
const signedCentsSchema = z.number().int().min(Number.MIN_SAFE_INTEGER).max(Number.MAX_SAFE_INTEGER);
export const financeReportingProjectFinancialsRequestSchema = z.strictObject({
    consumerModuleId: z.literal('reporting'),
    requestedCapability: z.literal('reporting.finance-project-performance.v1'),
    resourceType: z.literal('reporting.dataset'),
    resourceId: z.string().uuid(),
    projectIds: z.array(z.string().uuid()).min(1).max(500),
    asOf: z.string().datetime({ offset: true }),
}).superRefine(({ projectIds }, context) => {
    if (new Set(projectIds).size !== projectIds.length) {
        context.addIssue({ code: 'custom', path: ['projectIds'], message: 'Projects cannot repeat.' });
    }
});
export const financeReportingProjectFinancialFactSchema = z.strictObject({
    projectId: z.string().uuid(),
    currencyCode: z.literal('USD'),
    invoiceCount: z.number().int().nonnegative(),
    invoicedCents: centsSchema,
    collectedCents: centsSchema,
    writtenOffCents: centsSchema,
    outstandingCents: centsSchema,
    approvedDirectExpenseCount: z.number().int().nonnegative(),
    approvedDirectExpenseCents: centsSchema,
    referralCommissionCount: z.number().int().nonnegative(),
    referralCommissionCents: centsSchema,
    overheadCents: centsSchema,
    knownFinanceCostCents: centsSchema,
    knownFinanceContributionCents: signedCentsSchema,
}).superRefine((fact, context) => {
    if (fact.invoicedCents - fact.collectedCents - fact.writtenOffCents !== fact.outstandingCents) {
        context.addIssue({
            code: 'custom', path: ['outstandingCents'],
            message: 'Invoice money must reconcile exactly.',
        });
    }
    const knownCost = fact.approvedDirectExpenseCents + fact.referralCommissionCents +
        fact.overheadCents;
    if (knownCost !== fact.knownFinanceCostCents ||
        fact.invoicedCents - knownCost !== fact.knownFinanceContributionCents) {
        context.addIssue({
            code: 'custom', path: ['knownFinanceContributionCents'],
            message: 'Finance contribution must reconcile exactly.',
        });
    }
});
export const financeReportingProjectFinancialsResponseSchema = z.strictObject({
    state: z.literal('present'),
    capability: z.literal(financeReportingProjectFinancialsCapability),
    tenantId: z.string().uuid(),
    asOf: z.string().datetime({ offset: true }),
    projects: z.array(financeReportingProjectFinancialFactSchema).min(1).max(500),
    contentHash: z.string().regex(/^[a-f0-9]{64}$/),
}).superRefine(({ projects }, context) => {
    const ids = projects.map(({ projectId }) => projectId);
    if (new Set(ids).size !== ids.length) {
        context.addIssue({ code: 'custom', path: ['projects'], message: 'Projects cannot repeat.' });
    }
});
//# sourceMappingURL=finance-reporting-project-financials.contract.js.map